<script setup>
import { onMounted, watch } from "vue";
import { sfiStore } from "@/services/sfiService";

// Initialize data on component mount
const fetchData = async () => {
  try {
    // Use the store's fetchData method which now handles all filters
    await sfiStore.fetchData();
    console.log("Data fetched on initial load", sfiStore.data);
  } catch (error) {
    console.error("Error fetching data on initial load:", error);
  }
};

// Watch for changes in the store's filter values
watch(
  () => [
    sfiStore.startDate,
    sfiStore.endDate,
    sfiStore.age.length,
    sfiStore.subject.length,
    sfiStore.topic.length,
    sfiStore.period,
  ],
  () => {
    console.log("Store filters changed, fetching new data");
    // Don't fetch automatically on filter change as the FilterComponent
    // now handles this when applying filters
  },
  { deep: true }
);

onMounted(() => {
  // Initial data fetch
  fetchData();
});
</script>
